export default __webpack_public_path__ + "static/media/best_quality.6d69b146.svg";